import React from "react";

export default function UsersPage() {
  return (
    <div className="d-flex flex-row">
      USERS
    </div>
  );
}
